@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
<div class="content">
  @if (taskMessage()) {
    <div class="taskMessage">
      <p>{{ taskMessage() }}</p>
    </div>
  }
  @if (task() && task().baseTask) {
    <div class="taskDetail">
      <div class="displayRow">
        <span class="inputLabel">Task Name:</span>
        <span class="displayLabel">{{ task().baseTask.name }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Started:</span>
        <span class="displayLabel">{{ task().baseTask.startTime | date: 'M/d/yyyy hh:mm a' }}</span>
      </div>
      @if (task().baseTask.escalationTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Escalate:</span>
          <span class="displayLabel">{{ task().baseTask.escalationTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      @if (task().baseTask.autoCompleteTime) {
        <div class="displayRow">
          <span class="inputLabel">Will Autocomplete:</span>
          <span class="displayLabel">{{ task().baseTask.autoCompleteTime | date: 'M/d/yyyy hh:mm a' }}</span>
        </div>
      }
      <div class="displayRow">
        <span class="inputLabel">Assigned To:</span>
        <span class="displayLabel">{{ assignedTo() }}</span>
      </div>
    </div>
  }
  @if (entity()) {
    <div class="entityDetail">
      <div class="displayRow">
        <span class="inputLabel">Entity ID:</span>
        <a class="displayLabel" [href]="getEntityUrl()">{{ entity().id.entityId + ';' + entity().id.entityRevision }}</a>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Project:</span>
        <span class="displayLabel">{{ entity().projectName }}</span>
      </div>
    </div>
  }
  @if (task() && task().baseTask) {
    <div class="fpa-data">
      <div class="displayRow">
        <span class="inputLabel">Outside Sales Rep:</span>
        <span class="displayLabel">{{ task().outsideSalesRep }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Rep Office:</span>
        <span class="displayLabel">{{ task().repOffice }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Lead Time:</span>
        <span class="displayLabel">{{ task().leadTime }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Total List:</span>
        <span class="displayLabel">{{ task().totalList | currency: 'USD' }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Unit Qty:</span>
        <span class="displayLabel">{{ task().unitQuantity }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Published Multiplier:</span>
        <span class="displayLabel">{{ task().publishedMultiplier }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Original Requested Multiplier:</span>
        <span class="displayLabel">{{ task().initialRequestMultiplier }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Requested Multiplier:</span>
        <input class="input-field" [disabled]="isBusy()" [(ngModel)]="requestedMultiplier" />
      </div>
      <div class="displayRow">
        <span class="inputLabel">Margin &#64; Req Mult:</span>
        <span class="displayLabel">{{ task().margin }}</span>
      </div>
      @if (task().costBasis; as basis) {
        <div class="costBasis">
          <div class="costBasisTitle">Cost basis &#64; Req Mult</div>
          <div class="costBasisRow">
            <span class="costBasisSource">SKU cost report</span>
            <span class="costBasisCost">{{ basis.skuCost | currency: 'USD' }}</span>
            <span class="costBasisMargin">{{ basis.skuMarginPercent }}%</span>
            @if (basis.skuMissingMappingCount > 0) {
              <span class="costBasisNote">{{ basis.skuMissingMappingCount }} missing {{ basis.skuMissingMappingCount === 1 ? 'mapping' : 'mappings' }}</span>
            }
          </div>
          <div class="costBasisRow">
            <span class="costBasisSource">Auto-Cost</span>
            @if (basis.autoCostAvailable) {
              <span class="costBasisCost">{{ basis.autoCostTotal | currency: 'USD' }}</span>
              <span class="costBasisMargin">{{ basis.autoCostMarginPercent }}% ({{ basis.autoCostMarginPercentLow }}% – {{ basis.autoCostMarginPercentHigh }}%)</span>
              @if (basis.autoCostLinesWithoutEstimate > 0) {
                <span class="costBasisNote">{{ basis.autoCostLinesWithoutEstimate }} {{ basis.autoCostLinesWithoutEstimate === 1 ? 'line' : 'lines' }} without an estimate</span>
              }
              @if (basis.autoCostWarmingUp) {
                <span class="costBasisNote">Model warming up</span>
              }
            } @else {
              <span class="costBasisNote">Auto-Cost unavailable</span>
            }
          </div>
        </div>
      }
      <div class="displayRow">
        <span class="inputLabel">Sale Type:</span>
        <span class="displayLabel">{{ task().saleType }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Approval Status:</span>
        <span class="displayLabel">{{ task().approvalStatus }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Expected First Shipment:</span>
        <span class="displayLabel">{{ task().expectedFirstShipment }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Basis Of Design:</span>
        <span class="displayLabel">{{ task().basisOfDesign }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Competitor:</span>
        <span class="displayLabel">{{ task().competitor }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Specifying Engineer:</span>
        <span class="displayLabel">{{ task().specifyingEngineer }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Engineer Location:</span>
        <span class="displayLabel">{{ task().engineerLocation }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Bid Date:</span>
        <span class="displayLabel">{{ task().bidDate }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel">Other Details:</span>
        <span class="displayLabel">{{ task().otherDetails }}</span>
      </div>
      <div class="displayRow">
        <span class="inputLabel text-area-label">Comments:</span>
        <textarea rows="4" cols="80" class="no-resize" [(ngModel)]="comments"></textarea>
      </div>
    </div>
  }
  @if (costMappingIssueCount() > 0) {
    <div class="costMappingWarning">
      <div class="costMappingWarningHeader">
        <mat-icon class="size-16">warning</mat-icon>
        <span>{{ costMappingIssueCount() }} cost mapping issue(s) &mdash; margin may be overstated</span>
      </div>
      @if (costMappingIssues().paperPilot.length) {

        <div class="costMappingGroupHeader costMappingPaperPilot">Needs a PRMS key mapping (paper pilot) &mdash; a cost of $0 is being used</div>
        <ul class="costMappingWarningList">
          @for (issue of costMappingIssues().paperPilot; track issue) {
            <li>{{ issue }}</li>
          }
        </ul>
      }
      @if (costMappingIssues().warnings.length) {
        <div class="costMappingGroupHeader costMappingCaution">Cost warnings &mdash; verify before approving</div>
        <ul class="costMappingWarningList">
          @for (issue of costMappingIssues().warnings; track issue) {
            <li>{{ issue }}</li>
          }
        </ul>
      }
      @if (entity()) {
        <a class="cost-report-link" [href]="'entityCostReport/' + entity().id.entityId + '/' + entity().id.entityRevision">View Cost Report</a>
        <a class="cost-report-link" [href]="'autoCostReport/' + entity().id.entityId + '/' + entity().id.entityRevision">Auto-Cost Report</a>
      }
      @if (canCreatePaperPilot()) {
        <div class="paperPilotButtonRow">
          <button mat-raised-button class="buttonInput" [disabled]="isBusy()" (click)="createPaperPilot()">
            <span>
              <mat-icon class="size-16">flight_takeoff</mat-icon>
              <span class="buttonLabel">Create Paper Pilot</span>
            </span>
          </button>
        </div>
      }
    </div>
  }
  @if (canCloseTask()) {
    <div class="buttonRow">
      <span class="inputLabel"></span>
      <button matButton="elevated" class="buttonInput approveButton" (click)="closeTask(true)">
        <span>
          <mat-icon class="size-16">done</mat-icon>
          <span class="buttonLabel">Approve</span>
        </span>
      </button>
      <button matButton="elevated" class="buttonInput denyButton" (click)="closeTask(false)">
        <span>
          <mat-icon class="size-16">cancel</mat-icon>
          <span class="buttonLabel">Deny</span>
        </span>
      </button>
    </div>
  }
</div>
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <span class="busyLabel">Please Wait...</span>
    </div>
  </div>
}
